import { IClauseList } from "@/api";
import { useAuth } from "@/contexts/auth/useAuth";
import { Typography } from "@mui/material";
import { useDialogs } from "@toolpad/core/useDialogs";
import { ClauseDetailsDialog } from "../dialogs/clause-details-dialog/ClauseDetailsDialog";

interface IProps {
    /**
     * The clause to display
     */
    clause: IClauseList;
}

/**
 * Displays the title of a clause
 */
export const ClauseTitleCell = ({ clause }: IProps) => {
    const dialog = useDialogs();
    const { user } = useAuth();

    const handleClick = () => {
        dialog.open(ClauseDetailsDialog, {
            clause,
            user,
        });
    };

    return (
        <span onClick={handleClick} style={{ cursor: "pointer" }}>
            <Typography variant="body2" fontWeight={600}>
                {clause.title}
            </Typography>
            <Typography sx={{ width: 360 }} variant="caption" noWrap>
                {clause.description}
            </Typography>
        </span>
    );
};
